// we might want to look at auto-creating this

export const allPermissions: Array<string> = [
  "adjudication:claim_get",
  "adjudication:claim_list",
  "adjudication:document_attach",
  "adjudication:document_create",
  "adjudication:document_detach",
  "adjudication:document_list",
  "adjudication:document_update",
  "adjudication:document_url_for_download",
  "adjudication:document_url_for_upload",
  "adjudication:drug_get",
  "adjudication:drug_list",
  "adjudication:formulary_create",
  "adjudication:formulary_file_create",
  "adjudication:formulary_file_get",
  "adjudication:formulary_file_list",
  "adjudication:formulary_file_url_for_download",
  "adjudication:formulary_file_url_for_upload",
  "adjudication:formulary_get",
  "adjudication:formulary_list",
  "adjudication:group_accumulation_period_create",
  "adjudication:group_accumulation_period_list",
  "adjudication:group_accumulation_period_update",
  "adjudication:group_create",
  "adjudication:group_get",
  "adjudication:group_list",
  "adjudication:group_update",
  "adjudication:grouping_association_create",
  "adjudication:grouping_association_delete",
  "adjudication:grouping_association_get",
  "adjudication:grouping_association_list",
  "adjudication:grouping_association_update",
  "adjudication:grouping_association_relationship_create",
  "adjudication:grouping_association_relationship_delete",
  "adjudication:grouping_association_relationship_update",
  "adjudication:grouping_association_relationship_list",
  "adjudication:location_geolocate",
  "adjudication:mddb_drug_list",
  "adjudication:member_accumulation_list",
  "adjudication:member_calculate_accumulation_balances",
  "adjudication:member_create",
  "adjudication:member_create_print_request",
  "adjudication:member_get",
  "adjudication:member_list",
  "adjudication:member_recent_print_requests",
  "adjudication:member_update",
  "adjudication:member_versions_list",
  "adjudication:network_attach_agreements",
  "adjudication:network_create",
  "adjudication:network_get",
  "adjudication:network_get_agreements",
  "adjudication:network_list",
  "adjudication:network_update",
  "adjudication:override_create",
  "adjudication:override_create_restricted",
  "adjudication:override_get",
  "adjudication:override_list",
  "adjudication:override_update",
  "adjudication:pharmacy_get",
  "adjudication:pharmacy_list",
  "adjudication:plan_account_create",
  "adjudication:plan_account_get",
  "adjudication:plan_account_list",
  "adjudication:plan_account_update",
  "adjudication:plan_accumulation_period_create",
  "adjudication:plan_accumulation_period_list",
  "adjudication:plan_accumulation_period_update",
  "adjudication:plan_benefit_create",
  "adjudication:plan_benefit_duplicate",
  "adjudication:plan_benefit_get",
  "adjudication:plan_benefit_list",
  "adjudication:plan_benefit_update",
  "adjudication:plan_create",
  "adjudication:plan_get",
  "adjudication:plan_list",
  "adjudication:plan_update",
  "adjudication:price_list_create",
  "adjudication:price_list_get",
  "adjudication:price_list_list",
  "adjudication:price_list_update",
  "adjudication:prior_authorization_create",
  "adjudication:prior_authorization_list",
  "adjudication:prior_authorization_get",
  "adjudication:prior_authorization_update",
  "adjudication:provider_agreement_create",
  "adjudication:provider_agreement_date_create",
  "adjudication:provider_agreement_date_get",
  "adjudication:provider_agreement_date_list",
  "adjudication:provider_agreement_date_update",
  "adjudication:provider_agreement_get",
  "adjudication:provider_agreement_list",
  "adjudication:provider_agreement_pricing_create",
  "adjudication:provider_agreement_pricing_get",
  "adjudication:provider_agreement_pricing_list",
  "adjudication:provider_agreement_pricing_update",
  "adjudication:provider_agreement_update",
  "adjudication:provider_information_list",
  "adjudication:provider_reimbursements_create",
  "adjudication:provider_reimbursements_get",
  "adjudication:provider_reimbursements_list",
  "adjudication:provider_reimbursements_update",
  "adjudication:provider_reporting_create",
  "adjudication:provider_reporting_get",
  "adjudication:provider_reporting_list",
  "adjudication:provider_reporting_update",
  "adjudication:remitting_payment_create",
  "adjudication:remitting_payment_get",
  "adjudication:remitting_payment_list",
  "adjudication:remitting_payment_provider_information_list",
  "adjudication:remitting_payment_update",
  "adjudication:step_therapy_create",
  "adjudication:step_therapy_get",
  "adjudication:step_therapy_list",
  "adjudication:step_therapy_update",
  "adjudication:tag_create",
  "adjudication:tag_get",
  "adjudication:tag_list",
  "adjudication:tag_update",
  "adjudication:transmission_admin_reversal",
  "adjudication:transmission_batch_test_get",
  "adjudication:transmission_batch_test_list",
  "adjudication:transmission_batch_test_process",
  "adjudication:transmission_batch_test_url_for_download",
  "adjudication:transmission_batch_test_url_for_upload",
  "adjudication:transmission_process",
  "adjudication:transmission_process_test_as_batch",
  "adjudication:transmission_process_test_as_batch_lookup",
  "adjudication:transmission_process_unserialized",
  "adjudication:transmission_test",
  "adjudication:unified_accumulations_get",
  "adjudication:vendor_inbound_accumulator_create",
  "adjudication:vendor_inbound_accumulator_get",
  "adjudication:vendor_inbound_accumulator_list",
  "adjudication:vendor_inbound_accumulator_update",
  "adjudication:vendor_inbound_eligibility_create",
  "adjudication:vendor_inbound_eligibility_get",
  "adjudication:vendor_inbound_eligibility_list",
  "adjudication:vendor_inbound_eligibility_update",
  "adjudication:vendor_outbound_accumulator_create",
  "adjudication:vendor_outbound_accumulator_get",
  "adjudication:vendor_outbound_accumulator_list",
  "adjudication:vendor_outbound_accumulator_update",
  "adjudication:vendor_outbound_eligibility_create",
  "adjudication:vendor_outbound_eligibility_get",
  "adjudication:vendor_outbound_eligibility_list",
  "adjudication:vendor_outbound_eligibility_update",
  "adjudication:vendor_reporting_vendors_create",
  "adjudication:vendor_reporting_vendors_get",
  "adjudication:vendor_reporting_vendors_list",
  "adjudication:vendor_reporting_vendors_update",
  "adjudication:adjudication_data_report_create",
  "adjudication:adjudication_data_report_get",
  "adjudication:adjudication_data_report_list",
  "adjudication:adjudication_data_report_list_modules",
  "adjudication:adjudication_data_report_update",
  "app:drug_get",
  "app:drug_list",
  "app:drug_price_list",
  "app:favorite_pharmacy_create",
  "app:favorite_pharmacy_list",
  "app:favorite_pharmacy_update",
  "app:location_geolocate",
  "app:member_accumulation",
  "app:member_claim_list",
  "app:pharmacy_get",
  "app:pharmacy_list",
  "app:user_drug_defaults",
  "app:member_delete",
  "app:member_resend_verification",
  "app:member_reset_password",
  "iam:group_create",
  "iam:group_get",
  "iam:group_list",
  "iam:group_policy_attachment_create",
  "iam:group_policy_attachment_get",
  "iam:group_policy_attachment_list",
  "iam:identity_can",
  "iam:identity_create",
  "iam:identity_get",
  "iam:identity_get_all_policies",
  "iam:identity_group_membership_create",
  "iam:identity_group_membership_delete",
  "iam:identity_group_membership_get",
  "iam:identity_group_membership_list",
  "iam:identity_group_membership_set",
  "iam:identity_list",
  "iam:identity_policy_attachment_create",
  "iam:identity_policy_attachment_get",
  "iam:identity_policy_attachment_list",
  "iam:identity_update",
  "iam:policy_create",
  "iam:policy_get",
  "iam:policy_list",
];

export const testPermissions = ["no:lol"];

export const placeholderPermissions = ["iam:identity_can"];

/* The following is most significant permissions required for each page
 in Member Lookup */

export const memberGroupPlan = [
  "adjudication:member_get",
  "adjudication:group_get",
  "adjudication:plan_account_get",
  "adjudication:plan_get",
];

export const memberCreate = ["adjudication:member_create"];

export const memberEdit = ["adjudication:member_update"];

export const memberDependents = ["adjudication:member_list"];

export const memberAddDependents = ["adjudication:member_create"];

export const memberClaims = ["adjudication:claim_list"];

export const memberClaimsDetails = ["adjudication:claim_get"];

export const memberVersions = ["adjudication:member_versions_list"];

export const memberRequestCard = ["adjudication:member_recent_print_requests", "adjudication:member_create_print_request"];

export const memberAccumulations = ["adjudication:member_accumulation_list"];

export const memberCreateOverride = ["adjudication:override_create"];

export const memberCreateOverrideRestricted = ["adjudication:override_create_restricted"];

export const memberUpdateOverride = ["adjudication:override_update"];

export const memberUpdateOverrideRestricted = ["adjudication:override_update_restricted"];

export const memberOverrides = [...memberCreateOverride, ...memberUpdateOverride, "adjudication:override_list"];

export const memberAddAuthorization = ["adjudication:prior_authorization_create"];

export const memberUpdateAuthorization = ["adjudication:prior_authorization_update"];

export const memberAuthorizations = [...memberAddAuthorization, ...memberUpdateAuthorization, "adjudication:prior_authorization_list"];

export const memberAppAdminPermissions = ["app:member_delete", "app:member_resend_verification"];

export const memberPermissions = [
  ...memberGroupPlan,
  ...memberCreate,
  ...memberEdit,
  ...memberDependents,
  ...memberAddDependents,
  ...memberClaims,
  ...memberClaimsDetails,
  ...memberVersions,
  ...memberRequestCard,
  ...memberAccumulations,
  ...memberOverrides,
  ...memberAuthorizations,
  "adjudication:mddb_drug_list",
];

// Data Exchange
export const dataReportCreate = ["adjudication:adjudication_data_report_create"];
export const dataReportUpdate = ["adjudication:adjudication_data_report_update"];
export const dataReportGet = ["adjudication:adjudication_data_report_get"];
export const dataReportSearch = ["adjudication:adjudication_data_report_list", "adjudication:adjudication_data_report_list_modules"];

export const sftpCredentialCreate = ["adjudication:adjudication_sftp_credential_create"];
export const sftpCredentialUpdate = ["adjudication:adjudication_sftp_credential_update"];
export const sftpCredentialGet = ["adjudication:adjudication_sftp_credential_get"];
export const sftpCredentialSearch = ["adjudication:adjudication_sftp_credential_list"];
export const sftpCredentialPermissions = [...sftpCredentialCreate, ...sftpCredentialUpdate, ...sftpCredentialGet, ...sftpCredentialSearch];

export const sftpDeliveryTargetCreate = ["adjudication:adjudication_sftp_delivery_target_create"];
export const sftpDeliveryTargetUpdate = ["adjudication:adjudication_sftp_delivery_target_update"];
export const sftpDeliveryTargetGet = ["adjudication:adjudication_sftp_delivery_target_get"];
export const sftpDeliveryTargetSearch = ["adjudication:adjudication_sftp_delivery_target_list"];
export const sftpDeliveryTargetPermissions = [
  ...sftpDeliveryTargetCreate,
  ...sftpDeliveryTargetUpdate,
  ...sftpDeliveryTargetGet,
  ...sftpCredentialSearch,
];

export const dataReportViewOnly = [...dataReportGet, ...dataReportSearch];

// Used to check if the create button appears
export const credentialCreate = [...sftpCredentialCreate, ...sftpCredentialUpdate];
export const deliveryTargetCreate = [...dataReportCreate, ...dataReportUpdate, ...sftpDeliveryTargetCreate, ...sftpDeliveryTargetUpdate];

// Probably only used for routes since the pages are shared
export const dataReportPermissions = [...dataReportCreate, ...dataReportGet, ...dataReportSearch, ...dataReportUpdate];
export const deliveryTargetPermissions = [...sftpDeliveryTargetPermissions, ...dataReportPermissions];
export const credentialPermissions = [...sftpCredentialPermissions];

// Claims Lookup

export const claimsDetails = ["adjudication:claim_get"];

export const claimsPermissions = [...claimsDetails, "adjudication:claim_list"];

/* Plan Management
 XXX need to update for page specific items */
export const planCreate = ["adjudication:plan_create"];
export const planEdit = ["adjudication:plan_update"];
export const planManagementCreateBenefit = ["adjudication:plan_benefit_create"];
export const planManagementEditBenefit = ["adjudication:plan_benefit_update"];
export const planManagementUnlockBenefit = ["adjudication:plan_benefit_unlock"];
export const planRead = ["adjudication:plan_get"];

// the following is the most significant permissions for this module
export const planManagementPermissions = ["adjudication:plan_list"];
export const fullPlanManagementPermissions = [
  "adjudication:plan_list",
  "adjudication:plan_create",
  "adjudication:plan_get",
  "adjudication:plan_update",
  "adjudication:group_list",
  "adjudication:plan_benefit_list",
  "adjudication:group_update",
  "adjudication:plan_account_create",
  "adjudication:plan_account_list",
  "adjudication:group_create",
  "adjudication:plan_accumulation_period_list",
  "adjudication:plan_accumulation_period_update",
  "adjudication:plan_accumulation_period_create",
  "adjudication:plan_benefit_create",
  "adjudication:plan_benefit_update",
  "adjudication:tag_list",
  "adjudication:formulary_list",
  "adjudication:step_therapy_list",
  "adjudication:override_list",
  "adjudication:override_create",
  // need "adjudication:plan_benefit_update_dates",
];

export const reportingPermissions = ["adjudication:client_utilization_report_list"];

export const tagCreate = ["adjudication:tag_create"];
export const tagEdit = ["adjudication:tag_update"];
export const tagList = ["adjudication:tag_list"];
export const tagRead = ["adjudication:tag_get"];

export const overrideCreate = ["adjudication:override_create"];
export const overrideEdit = ["adjudication:override_update"];
export const overrideList = ["adjudication:override_list"];
export const overrideRead = ["adjudication:override_get"];

/* Formulary
XXX need to update for page specific items */

/* The following are endpoints for formulary but not used at this time in their permissioning since we only care about
read only vs edit access for now.
  "adjudication:formulary_list",
  "adjudication:formulary_file_list",
  "adjudication:formulary_file_url_for_upload",
  "adjudication:formulary_get",
*/

export const formularyPermissions = ["adjudication:formulary_create"];

/* Formulary
XXX need to update for page specific items */

/* The following are endpoints for network but not used at this time in their permissioning since we only care about
read only vs edit access for now.
    "adjudication:network_list",
    "adjudication:provider_agreement_list",
    "adjudication:network_get",
    "adjudication:network_get_agreements",
    "adjudication:network_attach_agreements",
*/
export const networkCreate = ["adjudication:network_create"];
export const networkAttach = ["adjudication:network_attach_agreements"];
export const networkUpdate = ["adjudication:network_update"];
export const agreementCreate = ["adjudication:provider_agreement_create"];
export const agreementEdit = ["adjudication:provider_agreement_update"];
export const agreementDateCreate = ["adjudication:provider_agreement_date_create"];
export const agreementPricingUpdate = ["adjudication:provider_agreement_pricing_update"];

// Test Claim Adjudication

export const singleTestClaim = [
  ...memberGroupPlan,
  "adjudication:member_list",
  "adjudication:pharmacy_get",
  "adjudication:pharmacy_list",
  "adjudication:mddb_drug_list",
  "adjudication:transmission_test",
];

export const testAsBatch = ["adjudication:transmission_process_test_as_batch"];

export const batchTestClaim = ["adjudication:transmission_batch_test_list"]; // need to add the upload
export const medicalTestClaim = ["adjudication:medical_single_test_claim_process"];

// the following is the most significant permissions for this module
export const reverseClaimPermissions = ["adjudication:transmission_admin_reversal"];
export const reprocessClaimPermissions = ["adjudication:transmission_reprocess_claim"];
export const getClaimLogsPermissions = ["adjudication:claim_get_logs"];

// Manual Claim Adjudication

export const manualClaimPermissions = ["adjudication:transmission_manual"];
export const batchManualClaim = ["adjudication:transmission_batch_manual_list"];
export const fullManualClaimPermissions = [...manualClaimPermissions, ...batchManualClaim, ...testAsBatch];
export const manualClaimLogPermissions = ["adjudication:claim_get_logs"];

// the following is the most significant permissions for this module
export const testClaimPermissions = ["adjudication:transmission_test"];
export const fullTestClaimPermissions = [...singleTestClaim, ...batchTestClaim];
export const testClaimLogPermissions = ["adjudication:claim_get_logs"];

export const memberDocumentsPermissions = [
  "adjudication:document_attach",
  "adjudication:document_create",
  "adjudication:document_detach",
  "adjudication:document_list",
  "adjudication:document_update",
  "adjudication:document_url_for_download",
  "adjudication:document_url_for_upload",
];

/* User Permissions
XXX need to update for page specific items */

export const userPermissions = [
  "iam:identity_list",
  "iam:identity_group_membership_list",
  "iam:identity_group_membership_set",
  "iam:identity_get",
  "iam:identity_update",
  "iam:identity_create",
];

export const callCenterPermissions = [
  "iam:identity_can",
  "iam:identity_get_all_policies",
  "adjudication:member_get",
  "adjudication:group_get",
  "adjudication:plan_account_get",
  "adjudication:plan_get",
  "adjudication:member_recent_print_requests",
  "adjudication:member_create_print_request",
  "adjudication:member_list",
  "adjudication:claim_get",
  "adjudication:member_accumulation_list",
  "adjudication:override_list",
  "adjudication:override_get",
  "adjudication:prior_authorization_list",
  "adjudication:member_versions_list",
  "adjudication:claim_get",
  "adjudication:claim_list",
  "adjudication:plan_list",
  "adjudication:group_list",
  "adjudication:plan_benefit_get",
  "adjudication:plan_benefit_list",
  "adjudication:plan_account_list",
  "adjudication:plan_accumulation_period_list",
  "adjudication:network_list",
  "adjudication:tag_list",
  "adjudication:formulary_list",
  "adjudication:step_therapy_list",
  "adjudication:pharmacy_get",
  "adjudication:pharmacy_list",
  "adjudication:mddb_drug_list",
  "adjudication:transmission_test",
  "adjudication:unified_accumulations_get",
  "adjudication:member_calculate_accumulation_balances",
  "app:member_delete",
  "app:member_resend_verification",
  "app:member_reset_password",
  "app:member_get_last_authenticated_date",
];

export const pharmacyTechPermissions = [
  "iam:identity_can",
  "iam:identity_get_all_policies",
  "adjudication:member_get",
  "adjudication:group_get",
  "adjudication:plan_account_get",
  "adjudication:plan_get",
  "adjudication:member_recent_print_requests",
  "adjudication:member_create_print_request",
  "adjudication:member_list",
  "adjudication:claim_get",
  "adjudication:member_accumulation_list",
  "adjudication:override_list",
  "adjudication:prior_authorization_list",
  "adjudication:member_versions_list",
  "adjudication:claim_get",
  "adjudication:claim_list",
  "adjudication:plan_list",
  "adjudication:group_list",
  "adjudication:plan_benefit_get",
  "adjudication:plan_benefit_list",
  "adjudication:plan_account_list",
  "adjudication:plan_accumulation_period_list",
  "adjudication:network_list",
  "adjudication:tag_list",
  "adjudication:formulary_list",
  "adjudication:step_therapy_list",
  "adjudication:pharmacy_get",
  "adjudication:pharmacy_list",
  "adjudication:mddb_drug_list",
  "adjudication:transmission_test",
  "adjudication:unified_accumulations_get",
  "adjudication:member_calculate_accumulation_balances",
  "adjudication:override_create",
  "adjudication:override_update",
  "adjudication:override_get",
  "adjudication:prior_authorization_create",
  "adjudication:prior_authorization_update",
  "app:member_delete",
  "app:member_resend_verification",
  "app:member_reset_password",
  "app:member_get_last_authenticated_date",
];

export const networkManagerPermissions = [
  "iam:identity_can",
  "iam:identity_get_all_policies",
  "adjudication:network_attach_agreements",
  "adjudication:network_create",
  "adjudication:network_get",
  "adjudication:network_get_agreements",
  "adjudication:network_list",
  "adjudication:network_update",
  "adjudication:provider_agreement_create",
  "adjudication:provider_agreement_date_create",
  "adjudication:provider_agreement_date_get",
  "adjudication:provider_agreement_date_list",
  "adjudication:provider_agreement_date_update",
  "adjudication:provider_agreement_get",
  "adjudication:provider_agreement_list",
  "adjudication:provider_agreement_pricing_create",
  "adjudication:provider_agreement_pricing_get",
  "adjudication:provider_agreement_pricing_list",
  "adjudication:provider_agreement_pricing_update",
  "adjudication:provider_agreement_update",
];

export const clinicalProgramsPermissions = [
  "adjudication:therapeutic_substitutions_file_process",
  "adjudication:therapeutic_substitutions_file_url_for_upload",
];

export const pricingLevelCreate = ["adjudication:pricing_level_create"];
export const pricingLevelEdit = ["adjudication:pricing_level_update"];
export const pricingLevelList = ["adjudication:pricing_level_list"];
export const pricingLevelRead = ["adjudication:pricing_level_get"];
export const pricingLevelPermissions = [...pricingLevelCreate, ...pricingLevelEdit, ...pricingLevelList, ...pricingLevelRead];
